import { render, staticRenderFns } from "./ModalChangeRole.vue?vue&type=template&id=01bf29fb&scoped=true&"
import script from "./ModalChangeRole.vue?vue&type=script&lang=js&"
export * from "./ModalChangeRole.vue?vue&type=script&lang=js&"
import style0 from "./ModalChangeRole.vue?vue&type=style&index=0&id=01bf29fb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01bf29fb",
  null
  
)

export default component.exports